import { defineStore } from 'pinia'
import { ref } from 'vue'
import authService, { type LoginRequest } from '@/services/auth.service'
import { setAuthenticated } from '@/services/api'

export const useAuthStore = defineStore('auth', () => {
  const displayName = ref('')
  const username = ref('')
  const isAuthenticated = ref(false)
  const initialized = ref(false)

  async function init() {
    try {
      const user = await authService.me()
      displayName.value = user.displayName
      username.value = user.username
      isAuthenticated.value = true
      setAuthenticated(true)
    } catch {
      isAuthenticated.value = false
    } finally {
      initialized.value = true
    }
  }

  async function login(request: LoginRequest) {
    const user = await authService.login(request)
    displayName.value = user.displayName
    username.value = user.username
    isAuthenticated.value = true
    setAuthenticated(true)
  }

  function clearAuth() {
    displayName.value = ''
    username.value = ''
    isAuthenticated.value = false
    setAuthenticated(false)
  }

  async function logout() {
    await authService.logout()
    clearAuth()
  }

  return { displayName, username, isAuthenticated, initialized, init, login, logout, clearAuth }
})
